/* Almla redesign: header, mega menu and mobile drawer.
   Ported from the Cortex Page Builder "Header and Mega Menu" design. The menu
   data (window.ALM_MENUS, ALM_NAV, ALM_SEC) is rendered by
   sections/alm-header.liquid from the section's blocks, so it stays editable
   in the theme editor. Links are kept relative so they resolve on any theme
   preview, not only the live domain. */
var ALM_MENUS = window.ALM_MENUS || {}, ALM_NAV = window.ALM_NAV || [], ALM_SEC = window.ALM_SEC || [];
const ALM_ICON_X = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" aria-hidden=\"true\"><path d=\"M5 5l14 14M19 5L5 19\"/></svg>";
const ALM_ICON_PLUS = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" aria-hidden=\"true\"><path d=\"M12 4v16M4 12h16\"/></svg>";
// Every .alm-chrome on the page gets its own instance, so a spec page can show
// several open states without cloning the script.
function almInitChrome(root){
  if (!root || root.dataset.almReady) return;
  root.dataset.almReady = "1";
  var bar = root.querySelector(".alm-bar");
  var mega = root.querySelector(".alm-mega");
  var nav = root.querySelector(".alm-nav--main");
  var drawer = root.querySelector(".alm-drawer");
  var closeTimer = null, active = "";
  function url(p){ return p || "#"; }

  nav.innerHTML = ALM_NAV.map(function(n){
    var m = n.key && ALM_MENUS[n.key];
    return '<div class="alm-item"><a ' + (m ? 'data-open="' + n.key + '" href="' + url(m.href) + '"' : 'href="' + url(n.href) + '"') + '>' + (m ? m.label : n.label) + '</a></div>';
  }).join("");

  function rows(m){
    var prod = m.src ? m.src === "products" : m.head !== "Collections";
    return '<div class="alm-list' + (m.items.length < 4 ? " is-one" : "") + '">' + m.items.map(function(it){
      return '<a class="alm-row' + (prod ? " is-prod" : "") + '" href="' + url(it.u) + '">'
        + '<span class="alm-thumb"><img src="' + it.i + '" alt="" loading="lazy" width="56" height="56"></span>'
        + '<span class="alm-rtxt"><span class="alm-rname">' + it.n + '</span><span class="alm-rdesc">' + it.d + '</span></span></a>';
    }).join("") + '</div>';
  }
  function draw(key){
    var m = ALM_MENUS[key];
    mega.innerHTML = '<div class="alm-links">' + m.links.map(function(l){ return '<a href="' + url(l[1]) + '">' + l[0] + '</a>'; }).join("") + '</div>'
      + '<div class="alm-cols"><p class="alm-colhead">' + m.head + '</p>' + rows(m) + '</div>';
  }
  // Sit the card under the item that opened it, kept inside the bar.
  function place(trigger){
    var br = bar.getBoundingClientRect(), tr = trigger.getBoundingClientRect();
    mega.style.left = "0px";
    var w = mega.offsetWidth;
    var left = Math.max(12, Math.min(tr.left - br.left - 18, br.width - w - 12));
    mega.style.left = left + "px";
  }
  function open(key){
    if (!ALM_MENUS[key]) return;
    var trigger = nav.querySelector('[data-open="' + key + '"]');
    if (key !== active){ active = key; draw(key); }
    root.classList.add("is-open");
    if (trigger) place(trigger);
    Array.prototype.forEach.call(nav.querySelectorAll("[data-open]"), function(a){ a.classList.toggle("on", a === trigger); });
  }
  function close(){
    root.classList.remove("is-open");
    Array.prototype.forEach.call(nav.querySelectorAll("[data-open]"), function(a){ a.classList.remove("on"); });
  }
  root.addEventListener("mouseover", function(e){
    if (window.matchMedia("(max-width:860px)").matches) return;
    clearTimeout(closeTimer);
    var trigger = e.target.closest("[data-open]");
    if (trigger){ open(trigger.getAttribute("data-open")); return; }
    var item = e.target.closest(".alm-item");
    if (item && !item.querySelector("[data-open]")) close();
  });
  root.addEventListener("mouseleave", function(){ closeTimer = setTimeout(close, 180); });

  // Drawer: one accordion per shop menu, then the straight links.
  var secs = ALM_NAV.map(function(n){
    var m = n.key && ALM_MENUS[n.key];
    if (!m) return '<div class="alm-dsec"><a class="alm-dlink" href="' + url(n.href) + '">' + n.label + '</a></div>';
    return '<div class="alm-dsec" data-dsec="' + n.key + '"><button class="alm-dtoggle" type="button" aria-expanded="false">' + m.label + ALM_ICON_PLUS + '</button>'
      + '<div class="alm-dbody"><div class="alm-dlinks">' + m.links.map(function(l){ return '<a href="' + url(l[1]) + '">' + l[0] + '</a>'; }).join("") + '</div>' + rows(m) + '</div></div>';
  }).join("");
  var more = ALM_SEC.map(function(s){ return s[2].map(function(d){ return '<a href="' + url(d[1]) + '">' + d[0] + '</a>'; }).join(""); }).join("");
  drawer.innerHTML = '<div class="alm-dhead"><a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + '" aria-label="Almla Active home"><img src="' + root.querySelector(".alm-logo").getAttribute("src") + '" alt="Almla Active"></a><button class="alm-dclose" type="button" data-drawer-close aria-label="Close menu">' + ALM_ICON_X + '</button></div>'
    + secs + '<div class="alm-dmore">' + more + '</div>';
  function drawerOpen(on){ root.classList.toggle("is-drawer", on); document.documentElement.style.overflow = on ? "hidden" : ""; }
  root.addEventListener("click", function(e){
    var trigger = e.target.closest("[data-open]");
    if (trigger && !root.classList.contains("is-open") && !window.matchMedia("(max-width:860px)").matches){ e.preventDefault(); open(trigger.getAttribute("data-open")); return; }
    if (e.target.closest("[data-drawer-open]")){ drawerOpen(true); return; }
    if (e.target.closest("[data-drawer-close]")){ drawerOpen(false); return; }
    var t = e.target.closest(".alm-dtoggle");
    if (t){ var s = t.parentNode, on = !s.classList.contains("is-open"); s.classList.toggle("is-open", on); t.setAttribute("aria-expanded", on); }
  });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape"){ close(); drawerOpen(false); } });
  var init = root.getAttribute("data-initial");
  if (init){ if (document.readyState === "complete") open(init); else window.addEventListener("load", function(){ open(init); }); open(init); }
  var dinit = root.getAttribute("data-initial-drawer");
  if (dinit){ root.classList.add("is-drawer"); var ds = drawer.querySelector('[data-dsec="' + dinit + '"]'); if (ds) ds.classList.add("is-open"); }
}
function almScan(){ Array.prototype.forEach.call(document.querySelectorAll(".alm-chrome"), almInitChrome); }
almScan();
// A spec page can carry more chromes further down than this script, so scan
// again once the whole document has parsed.
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", almScan);
else almScan();

/* The header is sticky, so anything else that pins to the top of the screen
   (the PDP buy box, the collection filters) needs to sit below it. Publish its
   live height as --alm-header-h; it changes with breakpoints and announcement. */
(function(){
  var h = document.querySelector(".alm-header-section");
  if (!h) return;
  function set(){ document.documentElement.style.setProperty("--alm-header-h", h.offsetHeight + "px"); }
  set();
  if ("ResizeObserver" in window) new ResizeObserver(set).observe(h);
  else window.addEventListener("resize", set);
})();

/* Phones and tablets: the search bar scrolls away with the page while the
   logo bar stays pinned (client feedback, Oct 13: "lets unfreeze it as you
   scroll down"). Where it is a full-width row (up to 1100px) it moves just
   below the sticky header section, so it sits in exactly the same spot at
   the top of the page and nothing jumps. Wider screens keep it in the bar. */
(function(){
  var sec = document.querySelector(".alm-header-section");
  var chrome = sec && sec.querySelector(".alm-chrome");
  var btn = chrome && chrome.querySelector(".alm-hsrch");
  if (!btn) return;
  var bar = chrome.querySelector(".alm-bar"), home = chrome.querySelector(".alm-utils");
  var row = document.createElement("div");
  // .alm-chrome keeps the bar's own search styles; data-alm-ready stops the
  // menu script treating it as a second header.
  row.className = "alm-chrome alm-srow";
  row.setAttribute("data-alm-ready", "1");
  var mq = window.matchMedia("(max-width:1100px)");
  function place(){
    if (mq.matches && btn.parentNode !== row){ sec.parentNode.insertBefore(row, sec.nextSibling); row.appendChild(btn); }
    else if (!mq.matches && btn.parentNode === row){ bar.insertBefore(btn, home); row.remove(); }
    stuck();
  }
  // A hairline under the pinned bar once the search row has scrolled away.
  var on = false;
  function stuck(){
    var s = btn.parentNode === row && row.getBoundingClientRect().bottom <= sec.getBoundingClientRect().bottom + 1;
    if (s !== on){ on = s; sec.classList.toggle("is-stuck", s); }
  }
  if (mq.addEventListener) mq.addEventListener("change", place); else mq.addListener(place);
  window.addEventListener("scroll", stuck, { passive: true });
  place();
})();
